import classNames from 'classnames';
import React from 'react';

import { Label } from '@eika/label';

import type { EFakturaId, PaymentType } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { EfakturaLink } from '../EfakturaLink';

import './FuturePaymentTitle.scss';

interface Props {
    futurePaymentType?: PaymentType;
    useLabel?: boolean;
    title?: string;
    eFaktura?: {
        id?: EFakturaId;
        loading?: boolean;
        show?: boolean;
    };
}

const FuturePaymentTitle: React.FC<Props> = ({ useLabel = false, futurePaymentType, title, eFaktura }) => {
    const translated = useTranslation();

    return (
        <div className={classNames('future-payment-title__wrapper', { 'with-label': useLabel })}>
            <h2 className="future-payment-title__title">{title ?? translated.futurePaymentTitle.payment}</h2>
            {useLabel && futurePaymentType && (
                <Label
                    className="future-payment-title__label"
                    size="small"
                    text={translated.futurePaymentType[futurePaymentType]}
                />
            )}
            {eFaktura && (eFaktura.show ?? false) && (
                <div className="future-payment-title__efaktura-link-wrapper">
                    <EfakturaLink eFakturaId={eFaktura.id} loading={eFaktura.loading} disabled={eFaktura.loading} />
                </div>
            )}
        </div>
    );
};

export default FuturePaymentTitle;
